export const QueryKeys = {
  GetCustomerPaymentProfiles: 'QueryKey_GetCustomerPaymentProfiles',
  GetCustomerUpcomingAppointment: 'QueryKey_GetCustomerUpcomingAppointment',
  Subscriptions: 'QueryKey_Subscriptions',
  Invoices: 'QueryKey_Invoices',
  AppointmentsHistory: 'QueryKey_AppointmentsHistory',
  GetCustomerAutoPaySettings: 'QueryKey_GetCustomerAutoPaySettings',
  GetCustomerDocuments: 'QueryKey_GetCustomerDocuments',
  GetPlanList: 'QueryKey_GetPlanList',
  GetCurrentPlan: 'QueryKey_GetCurrentPlan',
  GetPaymentServiceAuthToken: 'QueryKey_GetPaymentServiceAuthToken',
  GetCustomerProducts: 'QueryKey_GetCustomerProducts',
  GetCustomerProductUpgrades: 'QueryKey_GetCustomerProductUpgrades',
};
